<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <popup-add-waste-reason ref="popupAddWasteReason" type="Sales" />
    <div class="flex justify-between">
      <p>
        Sales waste reasons are used to track the reason for a waste of a
        product in the sales process.
      </p>
      <div class="flex justify-end">
        <vs-button
          icon="add"
          @click="$refs.popupAddWasteReason.show()"
          type="relief"
          color="primary"
          class="mr-3"
          >Add waste reason</vs-button
        >
      </div>
    </div>

    <!-- table -->
    <div class="data-list-list-view">
      <vs-table
        ref="table"
        class="mt-4"
        :max-items="50"
        :data="wasteReasons"
        @selected="onClicked"
      >
        <template slot="thead">
          <vs-th sort-key="name">Reason</vs-th>
          <vs-th sort-key="createdAt">Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div
                  class="product-name font-medium truncate flex flex-row items-center"
                >
                  <div class="flex justify-start">
                    <img width="40" :src="ProductIcon" />
                    <div class="ml-4">
                      <div v-if="tr.reason">
                        {{ tr.reason }}
                      </div>
                      <div v-else>
                        <vs-chip> No name </vs-chip>
                      </div>
                      <small>{{ tr.id }}</small>
                    </div>
                  </div>
                </div>
              </vs-td>

              <vs-td>
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-4"
                  @click.stop="confirmDelete(tr.id)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductIcon from "@/assets/images/product-icon.png";
import popupAddWasteReason from "./PopupAddWasteReason.vue";

export default {
  components: { popupAddWasteReason },
  data() {
    return {
      isLoading: true,
      toDelete: null,
      ProductIcon,
    };
  },
  methods: {
    confirmDelete(id) {
      this.toDelete = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Delete waste reason",
        text: "Are you sure you want to delete this waste reason?",
        accept: this.deleteWasteReason,
      });
    },
    deleteWasteReason() {
      this.$store.dispatch(
        "pos/countrySettings/deleteSalesWasteReason",
        this.toDelete
      );
      this.toDelete = null;
    },
    onClicked(item) {
      this.$refs.sidebar.show(item.id);
    },
    async onClickCreateNew() {
      this.$refs.popupAddWasteReason.show();
    },
  },
  computed: {
    ...mapGetters({
      wasteReasons: "pos/countrySettings/salesWasteReasons",
    }),
  },

  async created() {
    this.isLoading = true;
    await Promise.all([
      this.$store.dispatch("pos/countrySettings/getSalesWasteReasons"),
    ]);
    this.isLoading = false;
  },
};
</script>